const uzsFormatter = new Intl.NumberFormat('ru-RU', {
	maximumFractionDigits: 0,
})

/** Space-grouped UZS digits WITHOUT the currency word, e.g. 69000 -> "69 000". */
export function formatUzsAmount(amount: number): string {
	// Intl uses a non-breaking space (U+00A0) or narrow no-break space (U+202F)
	// for ru-RU grouping depending on ICU version; normalize all to a regular space
	// so output is predictable and testable.
	return uzsFormatter.format(amount).replace(/[   ]/g, ' ')
}

/** Formats a UZS amount with space-grouped thousands, e.g. 69000 -> "69 000 сум". */
export function formatUzs(amount: number): string {
	return `${formatUzsAmount(amount)} сум`
}
